exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sm[data-v-17d9e60e] {\n    min-height: 1.5rem;\n    min-width: 1.5rem;\n    max-height: 1.5rem;\n    max-width: 1.5rem;\n    font-size: 1rem;\n}\n.md[data-v-17d9e60e] {\n    min-height: 2.5rem;\n    min-width: 2.5rem;\n    max-height: 2.5rem;\n    max-width: 2.5rem;\n    font-size: 2rem;\n}\n.lg[data-v-17d9e60e] {\n    min-height: 3.5rem;\n    min-width: 3.5rem;\n    max-height: 3.5rem;\n    max-width: 3.5rem;\n    font-size: 3rem;\n}\n.round[data-v-17d9e60e] {\n    border-radius: 50%;\n}\n", ""]);

// exports
